// Vedic 45 Devata Names — compass-45 (Vedic)
export const Vedic_Devata_NAMES = [
  { srNo: 1,  blockNo: 1,  name: 'BRAHMA' },
  { srNo: 2,  blockNo: 2,  name: 'BHUDHAR' },
  { srNo: 3,  blockNo: 3,  name: 'ARYAMA' },
  { srNo: 4,  blockNo: 4,  name: 'VIVISWAN' },
  { srNo: 5,  blockNo: 5,  name: 'MITRA' },
  { srNo: 6,  blockNo: 6,  name: 'AAPAHA' },
  { srNo: 7,  blockNo: 7,  name: 'AAPAHA-VATSA' },
  { srNo: 8,  blockNo: 8,  name: 'SAVITA' },
  { srNo: 9,  blockNo: 9,  name: 'SAVITRA' },
  { srNo: 10, blockNo: 10, name: 'INDRA' },
  { srNo: 11, blockNo: 11, name: 'JAYA' },
  { srNo: 12, blockNo: 12, name: 'RUDRA' },
  { srNo: 13, blockNo: 13, name: 'RAJYA-KSHMA' },
  { srNo: 14, blockNo: 14, name: 'SHIKHI' },
  { srNo: 15, blockNo: 15, name: 'PARJANYA' },
  { srNo: 16, blockNo: 16, name: 'JAYANTI' },
  { srNo: 17, blockNo: 17, name: 'MAHENDRI' },
  { srNo: 18, blockNo: 18, name: 'SURYA' },
  { srNo: 19, blockNo: 19, name: 'SATYA' },
  { srNo: 20, blockNo: 20, name: 'BHRISHA' },
  { srNo: 21, blockNo: 21, name: 'ANTRIKSH' },
  { srNo: 22, blockNo: 22, name: 'ANIL' },
  { srNo: 23, blockNo: 23, name: 'PUSHA' },
  { srNo: 24, blockNo: 24, name: 'VITASTA' },
  { srNo: 25, blockNo: 25, name: 'GRIHSPATYA' },
  { srNo: 26, blockNo: 26, name: 'YAMA' },
  { srNo: 27, blockNo: 27, name: 'GANDHARVA' },
  { srNo: 28, blockNo: 28, name: 'BHRINGRAJ' },
  { srNo: 29, blockNo: 29, name: 'MRIGAH' },
  { srNo: 30, blockNo: 30, name: 'PITRA' },
  { srNo: 31, blockNo: 31, name: 'DAUWARIK' },
  { srNo: 32, blockNo: 32, name: 'SUGREEV' },
  { srNo: 33, blockNo: 33, name: 'PUUSHPDANT' },
  { srNo: 34, blockNo: 34, name: 'VARUN' },
  { srNo: 35, blockNo: 35, name: 'ASUR' },
  { srNo: 36, blockNo: 36, name: 'SHOSHA' },
  { srNo: 37, blockNo: 37, name: 'PAPYA-KSHMA' },
  { srNo: 38, blockNo: 38, name: 'ROGA' },
  { srNo: 39, blockNo: 39, name: 'AHIR' },
  { srNo: 40, blockNo: 40, name: 'MUKHYA' },
  { srNo: 41, blockNo: 41, name: 'BHALLAT' },
  { srNo: 42, blockNo: 42, name: 'SOMA' },
  { srNo: 43, blockNo: 43, name: 'BHUJAG' },
  { srNo: 44, blockNo: 44, name: 'ADITI' },
  { srNo: 45, blockNo: 45, name: 'DITI' }
];

// MODERN 45 Devata Names — compass-45-2 (Modern)
export const Devata_NAMES = [
  { srNo: 1,  blockNo: 1,  name: 'BRAHMA' },
  { srNo: 2,  blockNo: 2,  name: 'BHUDHAR' },
  { srNo: 3,  blockNo: 3,  name: 'ARYAMA' },
  { srNo: 4,  blockNo: 4,  name: 'VIVISWAN' },
  { srNo: 5,  blockNo: 5,  name: 'MITRA' },
  { srNo: 6,  blockNo: 6,  name: 'AAPAHA' },
  { srNo: 7,  blockNo: 7,  name: 'AAPAHA-VATSA' },
  { srNo: 8,  blockNo: 8,  name: 'SAVITA' },
  { srNo: 9,  blockNo: 9,  name: 'SAVITRA' },
  { srNo: 10, blockNo: 10, name: 'INDRA' },
  { srNo: 11, blockNo: 11, name: 'JAYA' },
  { srNo: 12, blockNo: 12, name: 'RUDRA' },
  { srNo: 13, blockNo: 13, name: 'RAJYA-KSHMA' },
  { srNo: 14, blockNo: 14, name: 'SHIKHI' },
  { srNo: 15, blockNo: 15, name: 'PARJANYA' },
  { srNo: 16, blockNo: 16, name: 'JAYANTI' },
  { srNo: 17, blockNo: 17, name: 'MAHENDRI' },
  { srNo: 18, blockNo: 18, name: 'SURYA' },
  { srNo: 19, blockNo: 19, name: 'SATYA' },
  { srNo: 20, blockNo: 20, name: 'BHRISHA' },
  { srNo: 21, blockNo: 21, name: 'ANTRIKSH' },
  { srNo: 22, blockNo: 22, name: 'ANIL' },
  { srNo: 23, blockNo: 23, name: 'PUSHA' },
  { srNo: 24, blockNo: 24, name: 'VITASTA' },
  { srNo: 25, blockNo: 25, name: 'GRIHSPATYA' },
  { srNo: 26, blockNo: 26, name: 'YAMA' },
  { srNo: 27, blockNo: 27, name: 'GANDHARVA' },
  { srNo: 28, blockNo: 28, name: 'BHRINGRAJ' },
  { srNo: 29, blockNo: 29, name: 'MRIGAH' },
  { srNo: 30, blockNo: 30, name: 'PITRA' },
  { srNo: 31, blockNo: 31, name: 'DAUWARIK' },
  { srNo: 32, blockNo: 32, name: 'SUGREEV' },
  { srNo: 33, blockNo: 33, name: 'PUUSHPDANT' },
  { srNo: 34, blockNo: 34, name: 'VARUN' },
  { srNo: 35, blockNo: 35, name: 'ASUR' },
  { srNo: 36, blockNo: 36, name: 'SHOSHA' },
  { srNo: 37, blockNo: 37, name: 'PAPYA-KSHMA' },
  { srNo: 38, blockNo: 38, name: 'ROGA' },
  { srNo: 39, blockNo: 39, name: 'AHIR' },
  { srNo: 40, blockNo: 40, name: 'MUKHYA' },
  { srNo: 41, blockNo: 41, name: 'BHALLAT' },
  { srNo: 42, blockNo: 42, name: 'SOMA' },
  { srNo: 43, blockNo: 43, name: 'BHUJAG' },
  { srNo: 44, blockNo: 44, name: 'ADITI' },
  { srNo: 45, blockNo: 45, name: 'DITI' }
];
